module.exports = __webpack_public_path__ + "media/assets/images/icon-close-cae0be771a3fe6485759ea1e1dbc71e7.svg";